<template>
    <button @click="reset()" type="button" class="btn text-uppercase btn-sm btn-warning btn-block">
        <li class="fa fa-tachometer"></li> Habilitar Hodômetro
    </button>
</template>
<script>
    import { Comandos } from '../../class';
    import { Bus } from '../../class/bus';
    export default {
        name: 'HabilitarHodmetro',
        props: {
            id_rastreador: {
                "default": null
            },

        },
        methods: {
            async reset () {
                await Comandos.habilitarHodometro(this.id_rastreador, true);
                Bus.$emit('comandos');
            }
        }
    }
</script>
